import ModalsLib from '../../../../../lib/modals';
import {useDispatch, useSelector} from 'react-redux';
import Selector from '../../../../../selectors/pages/tasks/daily/facebook_story';
import {showModal} from '../../../../../reducers/modules/actions';
import Diamond from '../../diamond';
import {navigate} from '../../../../../utils/navigation';
import Timer from './timer';

export default () => {
    const {task} = useSelector(Selector),
          dispatch = useDispatch();

    if(task.type === 'hidden')
        return <></>;

    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/facebook.png`} alt="Facebook Icon" />
                </div>
                <div className="title">Facebook Story</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Add our posts to story on Facebook to collect diamonds.
                </div>
                {task.type === 'available' ? ( 
                    <div className="button-block">
                        <div className="button" onClick={e => {
                            // ModalsLib.open('facebook_story', {
                            //     post: task.post
                            // });

                            dispatch(showModal('facebook_story'));
                        }}> 
                            Make story
                        </div>
                        <div className="diamonds">
                            <Diamond />
                            {task.reward}
                        </div>
                    </div>
                ) : <></>}

                {task.type === 'pending' ? (
                    <div className="button-block pending">
                        Pending
                    </div>
                ) : <></>}

                {task.type === 'timeout' ? (
                    <Timer timestamp={task.timestamp} />
                ) : <></>}
            </div>
        </div>
    )
}